var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M52.0124 7.99365V55.8687H12.0437V7.99365H52.0124V7.99365ZM52.0124 3.99365H12.0437C9.83745 3.99365 8.0437 5.7874 8.0437 7.99365V55.8687C8.0437 58.0749 9.83745 59.8687 12.0437 59.8687H52.0124C54.2187 59.8687 56.0124 58.0749 56.0124 55.8687V7.99365C56.0124 5.78115 54.2187 3.99365 52.0124 3.99365Z",
    fill: "#A2BE78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.308 60H29V49C29 46.7938 31.1074 45 33.6993 45H55.3006C57.8926 45 60 46.7938 60 49V56C60.0073 58.2125 57.9 60 55.308 60Z",
    fill: "#8DAB5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.688 57H40.2V49.872H42.804V48.504H36.084V49.872H38.688V57ZM43.8626 57H45.3746V48.504H43.8626V57ZM47.2985 57H48.8105V53.472H52.5545V52.104H48.8105V49.872H52.7825V48.504H47.2985V57Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.7688 37.35C42.3875 37.35 42.0126 37.3313 41.6376 37.3001C37.5126 36.9313 34.8251 34.7063 32.2313 32.5563C29.9376 30.6563 27.7688 28.8563 24.775 28.6375C20.7188 28.3438 16.2625 31.0875 11.525 36.7938L9.98755 35.5188C12.8813 32.0313 15.75 29.5375 18.5125 28.1063C20.6813 26.9875 22.8375 26.4938 24.925 26.6438C28.5563 26.9063 31.0751 28.9938 33.5126 31.0126C35.9813 33.0563 38.3125 34.9938 41.8188 35.3001C45.4063 35.6188 49.2125 34.1188 53.125 30.8313L54.4125 32.3625C50.4688 35.6813 46.5563 37.35 42.7688 37.35Z",
    fill: "#A2BE78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.9688 23.2499C37.9687 23.9073 38.0982 24.5583 38.3498 25.1657C38.6014 25.7731 38.9702 26.325 39.435 26.7899C39.8999 27.2547 40.4518 27.6235 41.0592 27.8751C41.6666 28.1267 42.3176 28.2562 42.975 28.2562C43.6324 28.2562 44.2834 28.1267 44.8908 27.8751C45.4982 27.6235 46.0501 27.2547 46.515 26.7899C46.9798 26.325 47.3486 25.7731 47.6002 25.1657C47.8518 24.5583 47.9813 23.9073 47.9813 23.2499C47.9813 22.5925 47.8518 21.9415 47.6002 21.3341C47.3486 20.7267 46.9798 20.1748 46.515 19.7099C46.0501 19.2451 45.4982 18.8763 44.8908 18.6247C44.2834 18.3731 43.6324 18.2437 42.975 18.2437C42.3176 18.2437 41.6666 18.3731 41.0592 18.6247C40.4518 18.8763 39.8999 19.2451 39.435 19.7099C38.9702 20.1748 38.6014 20.7267 38.3498 21.3341C38.0982 21.9415 37.9687 22.5925 37.9688 23.2499V23.2499Z",
    fill: "#A2BE78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTifIcon);
export default __webpack_public_path__ + "static/media/tif-icon.930609a2c54ae8f4be3ab5327f712301.svg";
export { ForwardRef as ReactComponent };